import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import IframeContent from './IframeContent';
import assist from '../images/BOTBlack.png';

// CSS mejorado para simular WhatsApp
const cssString = `
@import url('https://fonts.googleapis.com/css2?family=Spartan:wght@400;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;700&display=swap');

body, html {
  margin: 0;
  padding: 0;
  overflow: hidden;
  font-family: 'Spartan', sans-serif;
  font-size: 12px;
  font-weight: 700;
  background-color: transparent; /* Un gris profundo para la cabecera */
}

.chat-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.header {
  background-color: black; /* Un gris profundo para la cabecera */
  color: #E0E0E0; /* Texto en un gris claro para contraste */
  padding: 10px;
  font-size: 20px;
  text-align: left;
  display: flex;
  align-items: center;
  /* box-shadow eliminado */
  z-index:1;
}

.header img {
  /* box-shadow eliminado */
  border-radius: 50%;
  margin-right: 10px;
  width: 40px; 
  height: 40px;
}

.messages {
  min-height: 282px;
  flex-grow: 1;
  padding: 2px;
  overflow-y: auto;
  font-family: 'Open Sans', sans-serif;
  background-color: #2D2D2D; /* Un gris ligeramente más claro para el fondo de los mensajes */
  /* box-shadow eliminado */
}

.message {
  margin-top: 8px;
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 6px;
  padding: 8px 10px;
  border-radius: 10px; /* Bordes más redondeados */
  width: max-content;
  max-width: 60%;
  clear: both;
  color: #333; /* Texto oscuro para contraste con los colores pastel */
  /* box-shadow eliminado */
}

.message.sent {
  margin-left: auto;
  background-color: #5A7D9A; /* Azul grisáceo para mensajes enviados */
  color: #E0E0E0; /* Texto claro para contraste */
  font-weight:400;
  position: relative;
  z-index: +1;
}

.message.received {
  margin-right: auto;
  background-color: #4E5B6E; /* Gris azulado para mensajes recibidos */
  color: #D0D0D0; /* Texto ligeramente claro para contraste */
}

.message.typing {
  background-color: #4E5B6E; /* Gris azulado para mensajes recibidos */
  color: #aaa; /* Texto tenue para el mensaje de "escribiendo" */
  font-family: 'Open Sans', sans-serif;
  font-style: italic;
}

.input-container {
  display: flex;
  padding: 10px;
  background-color: black; /* Consistencia con el encabezado */
  max-height: 28px;
  /* box-shadow eliminado */
  z-index:1;
}

.input {
  flex-grow: 2;
  border: none;
  padding: 10px;
  margin-right: 5px;
  border-radius: 10px; /* Más redondeo para la barra de entrada */
  background-color: #404040; /* Gris medio para la barra de entrada */
  color: #E0E0E0; /* Texto claro para el input */
  font-size: 12px;
  /* box-shadow eliminado */
}

.input:focus {
  outline: none; /* Esto removerá el resplandor azul */
}

.send-button {
  background-color: #4A4A4A; /* Un gris que resalte para el botón de enviar */
  border: none;
  border-radius: 50%; /* Hace el botón completamente redondo */
  padding: 8px; /* Ajusta el padding según sea necesario para formar un círculo perfecto */
  color: #E0E0E0; /* Texto claro para el botón */
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px; /* Asegura un tamaño fijo para mantener la forma circular */
  height: 28px; /* Asegura un tamaño fijo para mantener la forma circular */
  transition: background-color 0.3s ease; /* box-shadow eliminado en las transiciones */
}


.send-button:hover {
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.6); /* Aumenta la sombra al pasar el ratón para un efecto más notorio */
}

.send-button:active {
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.4); /* Sombra más sutil cuando el botón está presionado */
  transform: scale(0.95);
}
`;

const Front = () => {
  const iframeRef = useRef(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

    const styleEl = document.createElement("style");
    styleEl.textContent = cssString;
    iframeDoc.head.appendChild(styleEl);

    ReactDOM.render(<IframeContent chat_id='Front' trainingPrompt='Te llamas Emilio Rosado, con formación avanzada en matemática pura tanto a nivel de licenciatura como de maestría. Tu pasión no se limita a las abstracciones numéricas; también te encanta el ejercicio físico, participando activamente en gimnasio y calistenia. Llevas una dieta predominantemente carnívora, consumiendo principalmente carne y pollo, que representa alrededor de la mitad de tu ingesta diaria de alimentos. Utilizas tu experiencia personal y profesional para ayudar a otros a alcanzar sus objetivos de fitness, nutrición y mejorar hábitos. Para los hombres, recomiendas rutinas de entrenamiento que incorporan elementos de calistenia, enfocadas en la fuerza. Para las mujeres, sugieres ejercicios específicos para el desarrollo de piernas y glúteos. Pero independiente de si es hombre o mujer siempre das rutinas que involucren los músculos del cuerpo entero y movimiento corporal. En cuanto a la nutrición, aplicas fórmulas estándar basadas en edad, género, altura y peso para calcular el requerimiento calórico diario de una persona y recomiendas que la ingesta de proteínas sea el doble del peso corporal en kilogramos. Por ejemplo, a alguien que pesa 60 kilogramos, le sugerirías consumir al menos 120 gramos de proteína al día. Te apasiona brindar consejos sobre la creación de hábitos saludables, entrenamiento físico y nutrición. Además, ofreces tu conocimiento experto en matemáticas para ayudar a las personas en cualquier aspecto relacionado con esta disciplina. Tu misión es inspirar y educar, aplicando un enfoque práctico y basado en evidencias para el bienestar integral.' chatName='Clones IA' chatImage={assist}/>, iframeDoc.body);
  }, []);

  return <iframe ref={iframeRef} style={{ width: '100%', height: '106%' }} title="Iframe Content"></iframe>;
};

export default Front;
